import Swal from 'sweetalert2';

const CONFIRM_DEFAULT_TITLE = 'Are you sure?';
const CONFIRM_DEFAULT_TEXT =
  'This action cannot be undone. Please confirm your decision to continue.';

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const CONFIRM_ICON_HTML = `
  <span class="metube-confirm-dialog__visual" aria-hidden="true">
    <span class="metube-confirm-dialog__sparkle metube-confirm-dialog__sparkle--left"></span>
    <span class="metube-confirm-dialog__circle">?</span>
    <span class="metube-confirm-dialog__sparkle metube-confirm-dialog__sparkle--right"></span>
  </span>
`;

const confirmDialogOptions = (title, text, confirmButtonText) => ({
  title: title || CONFIRM_DEFAULT_TITLE,
  html: `<p class="metube-confirm-dialog__text">${escapeHtml(
    text || CONFIRM_DEFAULT_TEXT
  )}</p>`,
  iconHtml: CONFIRM_ICON_HTML,
  icon: 'question',
  showCancelButton: true,
  showCloseButton: false,
  focusCancel: true,
  reverseButtons: true,
  buttonsStyling: false,
  confirmButtonText:
    typeof confirmButtonText === 'string' && confirmButtonText.trim()
      ? confirmButtonText.trim()
      : 'Yes, Continue',
  cancelButtonText: 'No, Cancel',
  customClass: {
    popup: 'metube-confirm-dialog',
    title: 'metube-confirm-dialog__title',
    htmlContainer: 'metube-confirm-dialog__content',
    icon: 'metube-confirm-dialog__icon',
    closeButton: 'metube-confirm-dialog__close',
    actions: 'metube-confirm-dialog__actions',
    cancelButton: 'metube-confirm-dialog__cancel',
    confirmButton: 'metube-confirm-dialog__confirm',
  },
});

export const alert = (title, data, type) => {
  return Swal.fire(title, data, type);
};

/**
 * Confirmation dialog. Keeps SweetAlert2 result shape ({ isConfirmed, ... }).
 * Supports: warning() | warning(null, text) | warning(title, text)
 * | warning(null, null, confirmButtonText)
 */
export const warning = (title, text, confirmButtonText) => {
  const resolvedTitle =
    typeof title === 'string' && title.trim() ? title.trim() : CONFIRM_DEFAULT_TITLE;
  const resolvedText =
    typeof text === 'string' && text.trim() ? text.trim() : CONFIRM_DEFAULT_TEXT;

  return Swal.fire(
    confirmDialogOptions(resolvedTitle, resolvedText, confirmButtonText)
  );
};

// Delete Warning for category
export const warningForText = (text) => {
  return Swal.fire(
    confirmDialogOptions(
      CONFIRM_DEFAULT_TITLE,
      typeof text === 'string' && text.trim() ? text.trim() : CONFIRM_DEFAULT_TEXT
    )
  );
};

// For Permission
export const permissionError = () => {
  return Swal.fire({
    confirmButtonColor: '#ff5e75',
    title: "Oops! You don't have permission.",
    icon: 'error',
  });
};
